import MedicationAnswer from "../abstract/MedicationAnswer"
import BoolQuestionAnswerStrategy from "../abstract/BoolQuestionAnswerStrategy"
import MedicationQuestion from "../abstract/MedicationQuestion"
import QuestionCreator from "../abstract/QuestionCreator"

export enum PatientSFQValues {
    v1="v1",
    v2="v2",
    v3="v3",
    v4="v4"
}

export interface PatientSFQPreconditions {
    v1: boolean,
    v2: boolean,
    v3: boolean,
    v4: boolean
}

export const PatientSFQValueList: PatientSFQValues[] = [
    PatientSFQValues.v1, PatientSFQValues.v2, PatientSFQValues.v3, PatientSFQValues.v4
]

export const PatientSFQValueNames: Record<PatientSFQValues, string> = {
    [PatientSFQValues.v1]: "Hatte der Patient/die Patientin in den letzten 6 Monaten bzw. seit dem letzten Ausfüllen dieser Fragen über Schwindel oder eine anhaltende orthostatische Hypotonie berichtet?",
    [PatientSFQValues.v2]: "Hatte der Patient/die Patientin in den letzten 6 Monaten bzw. seit dem letzten Ausfüllen dieser Fragen über einer anhaltenden Verstopfung berichtet?",
    [PatientSFQValues.v3]: "Hat der Patient/die Patientin in den letzten 6 Monaten bzw. seit dem letzten Ausfüllen dieser Fragen über sexuelle Funktionsstörungen berichtet?",
    [PatientSFQValues.v4]: "Ist der Patient/die Patientin im letzten Jahr bzw. seit dem letzten Ausfüllen dieser Fragen gestürzt?"
}

const PatientHasSFQValue =
    (
        condition: PatientSFQValues,
        answer: MedicationAnswer,
        optional: {
            strategy: BoolQuestionAnswerStrategy
            followedBy?: MedicationQuestion
            alternativeAnswer?: MedicationAnswer
        } = { strategy: BoolQuestionAnswerStrategy.ON_YES }
    ): QuestionCreator =>
        (input) =>
            new MedicationQuestion(
                PatientSFQValueNames[condition],
                input
            ).answerAutomatically((input) => {
                if(!input.sfqPreconditions)
                    throw "no sfq preconditions found - this question cannot be answered automatically"
                const fulfilled: boolean = input.sfqPreconditions[condition]
                if (fulfilled) {
                    return optional.strategy === BoolQuestionAnswerStrategy.ON_YES
                        ? answer
                        : optional.alternativeAnswer
                            ? optional.alternativeAnswer
                            : new MedicationAnswer("Ja")
                }
                return optional.strategy === BoolQuestionAnswerStrategy.ON_NO
                    ? answer
                    : optional.alternativeAnswer
                        ? optional.alternativeAnswer
                        : new MedicationAnswer("Nein")
            })
                .dontAnswerAutomaticallyIf(input => input.sfqPreconditions === null)
                .attachAnswer(answer)
                .attachAnswer(new MedicationAnswer("Nein"))

export default PatientHasSFQValue
